export default __webpack_public_path__ + "static/media/icon_arrow_down_light.0306b0ac.svg";